export default "__VITE_ASSET__ce0a1495__"